import React from "react";
import { ArrowUpRight } from "lucide-react";
import { MOTORCYCLE_PRODUCTS, LINKS } from "../mock/data";
import useReveal from "../hooks/useReveal";

function MotoCard({ product, i }) {
  const { ref, inView } = useReveal();
  return (
    <a
      ref={ref}
      href={LINKS.motoShop}
      target="_blank"
      rel="noopener noreferrer"
      style={{ animationDelay: `${i * 0.12}s` }}
      className={`reveal ${inView ? "in-view" : ""} group relative block overflow-hidden bg-[#0a0a0a] border border-white/10 hover:border-baja-red transition-colors duration-300`}
    >
      <div className="relative h-80 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[900ms]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <span className="absolute top-4 left-4 bg-baja-red text-white font-cond uppercase text-xs tracking-wider px-3 py-1">
          {product.category}
        </span>
        <div className="absolute bottom-0 left-0 p-6 w-full">
          <div className="flex items-center justify-between">
            <h3 className="font-display text-2xl uppercase text-white">{product.name}</h3>
            <ArrowUpRight className="text-white/60 group-hover:text-baja-red group-hover:rotate-45 transition-all duration-300" />
          </div>
          <p className="mt-3 text-white/60 text-sm leading-relaxed">{product.desc}</p>
        </div>
      </div>
    </a>
  );
}

export default function MotorcycleSection() {
  const { ref, inView } = useReveal();
  return (
    <section id="motorcycle" className="bg-[#0a0a0a] py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""} max-w-2xl`}>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-baja-red" />
            <span className="font-cond uppercase tracking-[0.25em] text-sm baja-red">Motorcycle Range</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] text-white">
            RIDE INTO THE NIGHT
          </h2>
          <p className="mt-5 text-white/60 text-lg leading-relaxed">
            Adventure, dual-sport and touring. Vibration-tested auxiliary lights and headlight kits engineered for riders who don't stop when the sun goes down.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {MOTORCYCLE_PRODUCTS.map((p, i) => (
            <MotoCard key={p.id} product={p} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
